import { jsx as _jsx } from "react/jsx-runtime";
import * as RetailerPaths from "@faire/retailer-visitor-shared/paths/index";
import { getCurrentPath } from "@faire/web--source/common/Path";
import React from "react";
import { Redirect } from "react-router-dom";
export var SignInAndRedirect = function() {
    var _getCurrentPath_searchParams_get;
    return /*#__PURE__*/ _jsx(Redirect, {
        to: RetailerPaths.home({
            signIn: "1",
            email: (_getCurrentPath_searchParams_get = getCurrentPath().searchParams.get("email")) !== null && _getCurrentPath_searchParams_get !== void 0 ? _getCurrentPath_searchParams_get : undefined,
            redirectTo: getCurrentPath().toString()
        })
    });
};
